<template>
  <div class="w-full" :key="reRenderKey">
    <div v-if="shownAlert" class="mb-12">
      <zt-alert :color="statusAlert" close-icon filled @afterClosed="shownAlert = false" class="message px-3 py-3">
        <div slot="custom-content">
          <div class="flex justify-start items-center">
            <zt-icon v-if="iconName" :name="iconName" class="icon mr-3"></zt-icon>
            <p>{{ messageAlert }}</p>
          </div>
        </div>
      </zt-alert>
    </div>
    <div class="w-full custom-input mb-10  relative">
     <ValidationProvider
        ref="fieldName"
        :rules="{ required: true, min: 3, max: 150, regex: nameRegex }"
        v-slot="{ errors, failedRules, invalid, validate }"
      >
        <zt-input
          v-model="params.nick_name"
          class="w-full"
          outlined
          :color="invalid ? 'danger' : 'primary'"
          :label="$t('message.selfService.fields.name')"
          data-vs-input="name"
          @input="validate"
          @blur="validate"
        />
        <validation-message v-if="errors.length" :rules="{ errors, failedRules, invalid, fieldName: 'name' }" />
      </ValidationProvider>
    </div>
    <div class="w-full mb-10 custom-input relative">
      <div class="select border-solid relative border-collapse" :class="{
        'border-zt-primary-200': genreFocus,
        'border-zt-dark-300': !genreFocus,
        'border-zt-danger': genreFocus && !isSelectValue,
        'border-zt-xs': !genreFocus,
        'border-2': genreFocus
      }">
        <label class="absolute pointer-events-none" :class="{
          focus: genreFocus || isSelectValue,
          'text-zt-primary-200': genreFocus && isSelectValue,
          'text-zt-dark-300': !genreFocus,
          'text-zt-danger': genreFocus && !isSelectValue
        }">
          {{ $t('message.selfService.fields.genre') }}
        </label>
        <select name="genre" v-model="params.genre" class="w-full h-full outline-none border-none"
          @focus="genreFocus = true" @blur="onSelectBlur" @change="onSelectBlur" data-vs-select="genre">
          <option value="">{{ $t("message.searchComponent.select_options") }}</option>
          <option v-for="(item, i) in items" :key="i" :value="item.value">{{
            item.label
          }}</option>
        </select>
        <validation-message v-if="genreError"
          :rules="{ failedRules: { 'required': true }, invalid: genreError, fieldName: 'genre' }" class="mt-2" />
      </div>
    </div>
    <div class="mb-12 font-normal">
      <h2 class="custom-title custom-color-gray font-medium mb-4">
        {{ $t('message.selfService.fields.photo.title') }}
      </h2>
      <p class="custom-legend text-zt-dark-300 mb-4">
        {{ $t('message.selfService.fields.photo.description') }}
      </p>
      <div class="w-full radio-group">
        <zt-radio-button :value="'false'" v-model="selected" name="visible" @change="update">
          <span class="custom-label">{{
            $t('message.selfService.fields.photo.notOk')
          }}</span>
        </zt-radio-button>
      </div>
      <div class="w-full">
        <zt-radio-button :value="'true'" v-model="selected" name="visible" @change="update">
          <span class="custom-label">{{
            $t('message.selfService.fields.photo.isOk')
          }}</span>
        </zt-radio-button>
      </div>
    </div>
    <div id="selfServiceInputFile" class="w-full custom-input mb-12" v-if="loadPicture">
      <zt-input-file v-model="params.file" @change="selectFile" outlined
        :label="$t('message.searchComponent.load_photo')" prepend-outer-icon="paperclip-2"
        accept="image/png, image/jpeg" data-vs-input="file">
        <template slot="message">
          <span class="text-zt-danger" v-if="fileError">{{ fileError }}</span>
        </template>
      </zt-input-file>
    </div>
    <div class="flex justify-end w-full">
      <zt-button v-if="pendingApprove" @click="cancelDialog = true">{{ $t("message.licenseComponent.licenseBox.cancel")
        }}</zt-button>
      <zt-button v-else :disabled="isNotAvailable" :loader="isLoading" @click="save" data-vs-button="save">
        {{ $t('message.selfService.actions.save') }}
      </zt-button>
    </div>

    <self-service-cancel-dialog v-if="pendingApprove" :active="cancelDialog" @close-modal="closeModal"
      @confirm="cancelRequest" />
  </div>
</template>

<script>
import Users from '@/apiClient/Users'
import { isEqual } from 'lodash'
import ValidationMessage from '../generic/ValidationMessage'
import SelfServiceCancelDialog from './SelfServiceCancelDialog'
import parseNull from '@/utils/parseNull'
const icons = {
  danger: 'exclamation-circle-solid',
  info: 'info-circle-solid'
}
const nameRegex = /^[\p{L}\p{M}\s()',.\-’´]+$/u;
const bool = [true, 't', 1]
export default {
  name: 'SelfServiceMyIdentifyInfo',
  components: { ValidationMessage, SelfServiceCancelDialog },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    updateFn: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      fileError: '',
      genreError: false,
      genreFocus: false,
      nameRegex,
      items: [
        {
          label: this.$t("message.homeComponent.men"),
          value: 'M'
        },
        {
          label: this.$t("message.homeComponent.women"),
          value: 'F'
        },
        {
          label: this.$t("message.homeComponent.noBinary"),
          value: 'N'
        }
      ],
      isLoading: false,
      isNotAvailable: true,
      loadPicture: false,
      params: {
        nick_name: '',
        genre: '',
        file: ''
      },
      pendingApprove: false,
      selected: 'false',
      shownAlert: false,
      statusAlert: 'info',
      messageAlert: '',
      cache: {},
      cancelDialog: false,
      cancelRequesting: false,
      reRenderKey: 0,
      totalSize: 0,
      typeDataStorage: ''
    }
  },
  watch: {
    params: {
      async handler(newParams) {
        if (this.info.pending && !isEqual(this.cache, this.params))
          this.pendingApprove = false
        else this.pendingApprove = this.info.pending
        for (const [key, value] of Object.entries(newParams)) {
          if (key !== 'genre') {
            const isError = await this.checkFieldError()
            this.isNotAvailable = isError || isEqual(this.cache, this.params)
            if (isError) break
          }
          if (key === 'genre' && value) {
            this.genreError = false
          }
          if (key === 'genre' && !value) {
            this.isNotAvailable = true
            this.genreError = true
            break
          }
        }
      },
      deep: true
    },
    info() {
      this.infoUpdate()
    },
    totalSize(newValue) {      
      const totalSizeElement = document.querySelector('#selfServiceInputFile span.text-zt-dark-400.text-zt-xs')
      const message = newValue > 0 ? `1 ${this.$t('message.DocumentsComponents.fileTitle')} (${this.totalSize} ${this.typeDataStorage} ${this.$t('message.DocumentsComponents.connectorFile')})` : ''
      totalSizeElement.textContent = message
    }
  },
  computed: {
    isSelectValue() {
      return this.genre !== ''
    },
    iconName() {
      return icons[this.statusAlert]
    }
  },
  created() {
    this.userApi = new Users()
    this.infoUpdate()
  },
  methods: {
    selectFile(file) {
      this.fileError = ''
      const type = file && file.type.split('/').pop()
      if (!['png', 'jpg', 'jpeg'].includes(type)) {
        this.totalSize = 0
        this.fileError = this.$t('message.selfService.fieldsError.file.format')
        return
      }
      if (file.size > 2000000) {
        this.totalSize = 0
        this.fileError = this.$t('message.selfService.fieldsError.file.size')
        return
      }
      this.params.file = file
      this.setFileSize(file.size)
    },
    setFileSize(size) {
      if(size < 10000){
        this.totalSize = (size / 1024).toFixed(2)
        this.typeDataStorage = 'KB'
      } else {
        this.totalSize = (size / 1048576).toFixed(2)
        this.typeDataStorage = 'MB'
      }
    },
    update() {
      this.loadPicture = /^(true|1)$/i.test(this.selected) && !!this.selected
      this.params.file = ''
      if (this.loadPicture) this.isNotAvailable = true
    },
    onSelectBlur() {
      this.genreFocus = false
    },
    async save() {
      if (this.isNotAvailable) return
      if (this.loadPicture && !this.params.file) {
        this.fileError = this.$t(
          'message.selfService.fieldsError.file.required'
        )
        return
      }
      this.isLoading = true
      const body = {
        nick_name: this.params.nick_name,
        genre: this.params.genre
      }
      if (this.params.file) body['file'] = this.params.file
      if (body.id) delete body.id
      if ('sichernpeople' in body) delete body.sichernpeople
      try {
        await this.userApi.saveIndentifyInfo(body)
        await this.updateFn()
        this.isLoading = false
        this.shownAlert = true
        this.isNotAvailable = true
        this.statusAlert = 'info'
        this.messageAlert = this.$t('message.selfService.response.success')
      } catch (e) {
        const code = e.response.data.codes[0].code
        this.messageAlert = this.$t(
          `message.selfService.response.errors.${code}`
        )
        this.isLoading = false
        this.isNotAvailable = false
        this.shownAlert = true
        this.statusAlert = 'danger'
      }
    },
    async checkFieldError() {
      for (const [, provider] of Object.entries(this.$refs)) {
        if (provider) {
          const { valid } = await provider.validate()
          if (!valid) return true
        }
      }
      return false
    },
    infoUpdate() {
      const { pending, url_picture, file, ...rest } = this.info
      this.cache = { file, ...parseNull({ ...rest }) }
      this.params = { file, ...parseNull({ ...rest }) }
      this.pendingApprove = pending
      this.messageAlert = this.$t('message.selfService.response.success')
      this.statusAlert = 'info'
      this.loadPicture = bool.includes(url_picture)
      this.selected = bool.includes(url_picture).toString()
      this.reRenderKey += 1
    },
    async cancelRequest() {
      this.cancelRequesting = true
      try {
        await this.userApi.cancelSelfServiceRequest(this.info.id)
        await this.updateFn()
        this.cancelRequesting = false
        this.closeModal()
        this.messageAlert = this.$t(
          'message.selfService.response.successCancel'
        )
        this.statusAlert = 'info'
        this.shownAlert = true
      } catch (e) {
        if (e.response.status === 404) {
          this.messageAlert = this.$t(
            `message.selfService.response.errors.notFound`
          )
        } else {
          const code = e.response.data.codes[0].code
          this.messageAlert = this.$t(
            `message.selfService.response.errors.${code}`
          )
        }
        this.isLoading = false
        this.isNotAvailable = false
        this.shownAlert = true
        this.statusAlert = 'danger'
        this.cancelRequesting = false
        this.closeModal()
      }
    },
    closeModal() {
      if (this.cancelRequesting) return
      this.cancelRequesting = false
      this.cancelDialog = false
    }
  }
}
</script>

<style scoped lang="scss">
.custom-input {
  ::v-deep {
    .zt-label.zt-label-active {
      background: #ffff !important;
      padding: 2px !important;
    }

    .zt-input {
      font-size: 1.125rem;
    }
  }
}

.custom-color-gray {
  color: rgba(45, 45, 45, 1);
}

.custom-title {
  font-size: 1.5rem;
}

.custom-legend {
  font-size: 1.125rem;
}

.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: rgba(45, 45, 45, 1);
}

.select {
  height: 50px;
  width: 100%;
  border-radius: 5px;
  padding: 8px;

  label {
    height: 20px;
    line-height: 20px;
    top: 50%;
    background: #fff;
    padding: 0 2px;
    transform: scale(1) translate(0, -50%);
    transform-origin: top left;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }

  .focus {
    top: 0;
    transform: scale(0.8) translate(0, -50%);
  }
}

::v-deep {
  .zt-input-radiobutton {
    label {
      padding-top: 3px;
    }

    i {
      font-size: 1.5rem;
      line-height: 1;
    }
  }
}
</style>
